import { api } from './api';

export type AccountKind = 'section' | 'account' | 'subaccount';
export type StatementType = 'pl' | 'asset' | 'liability' | 'equity';
export type StatutoryCategory =
  | 'revenue' | 'cogs' | 'opex' | 'non_op_income' | 'non_op_expense' | 'extra_income' | 'extra_loss' | 'tax';
export const STATUTORY_CATEGORIES: StatutoryCategory[] =
  ['revenue', 'cogs', 'opex', 'non_op_income', 'non_op_expense', 'extra_income', 'extra_loss', 'tax'];

/** A node in the account hierarchy (科目階層). Shape mirrors the backend row. */
export interface AccountNode {
  id: string;
  code: string | null;        // null for sections
  label: string;
  category: string | null;
  parent_id: string | null;
  kind: AccountKind;
  sign: number;               // +1 | -1
  is_subtotal: boolean;
  sort_order: number;
  statement_type: StatementType | null;
  statutory_category: StatutoryCategory | null;
}

export const accountsApi = {
  async list(wsId: string): Promise<AccountNode[]> {
    const r = await api.get<AccountNode[]>(`/api/workspaces/${wsId}/accounts`);
    return r.data;
  },
  async create(wsId: string, body: {
    label: string; kind?: AccountKind; code?: string | null; parentId?: string | null;
    sign?: number; isSubtotal?: boolean; sortOrder?: number;
  }): Promise<AccountNode> {
    const r = await api.post<AccountNode>(`/api/workspaces/${wsId}/accounts`, body);
    return r.data;
  },
  async update(wsId: string, id: string, patch: {
    label?: string; parentId?: string | null; sign?: number; isSubtotal?: boolean; sortOrder?: number; kind?: AccountKind;
    statementType?: StatementType | null;
    statutoryCategory?: StatutoryCategory | null;
  }): Promise<AccountNode> {
    const r = await api.patch<AccountNode>(`/api/workspaces/${wsId}/accounts/${id}`, patch);
    return r.data;
  },
  async remove(wsId: string, id: string): Promise<{ unmapped: boolean }> {
    const r = await api.delete<{ unmapped: boolean }>(`/api/workspaces/${wsId}/accounts/${id}`);
    return r.data;
  },
};
